import React, { useEffect, useState } from "react";
import axios from "axios";
import "./ParentSignUp.css";
import { Formik, Form, Field } from "formik";
import { Input } from "../TextField/TextField";
import * as Yup from "yup";
import { Link, useHistory } from "react-router-dom";
import Header from "../../layout/Header/Header";
import LoadingModal from "../../layout/LoadingModal/LoadingModal";
import { config } from "../../Constant";
import Button from "../Button/Button";
import { SuccessToast, ErrorToast } from "../Toast/Toast";
// import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { getDeviceId } from "../../utils/getDeviceId";

const API_URL = config.url.API_URL;

const ParentSignup = () => {
  const [modalShow, setModalShow] = useState(false);
  const history = useHistory();
  const [deviceId, setDeviceId] = useState("");

  const validationSchema = Yup.object({
    fullName: Yup.string()
      .max(34, "Must be 34 characters or less")
      .required("Full Name is Required"),
    email: Yup.string().email("Email is invalid").required("Email is required"),
    phoneNumber: Yup.string()
      .max(11, "phoneNo must be at least 11 digits")
      .required("Phone number is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Password must match")
      .required("Confirm your password"),
  });

  const query = new URLSearchParams(window.location.search);
  const referralCode = query.get("referral");

  // Load device fingerprint
  // useEffect(() => {
  //   const loadFingerprint = async () => {
  //     const fp = await FingerprintJS.load();
  //     const result = await fp.get();
  //     setDeviceId(result.visitorId);
  //   };
  //   loadFingerprint();
  // }, []);

  // Load persistent device ID
  useEffect(() => {
    (async () => {
      const id = await getDeviceId();
      setDeviceId(id);
    })();
  }, []);

  const handleSignup = async (values) => {
    setModalShow(true);
    try {
      const payload = {
        ...values,
        referral: referralCode,
        plan: "Basic",
        device_id: deviceId,
      };

      const response = await axios.post(`${API_URL}/nimdee/register`, payload);

      setModalShow(false);

      if (response.status === 201) {
        SuccessToast(response.data.message);

        // If there's a payment URL in the response, redirect to Paystack
        if (response.data.paymentUrl) {
          window.location.href = response.data.paymentUrl;
        } else {
          // For Basic plan or if no payment is needed
          setTimeout(() => {
            history.push("/childlogin");
          }, 2000);
        }
      }
    } catch (error) {
        const errorMessage =
        error.response?.data?.message;
      ErrorToast(errorMessage);
        //  console.error(" error:", error.response?.data?.message);
      setModalShow(false);
      
    }
  };

  const getSelectedPlan = JSON.parse(localStorage.getItem("plans"));

  return (
    <Formik
      initialValues={{
        fullName: "",
        email: "",
        phoneNumber: "",
        password: "",
        confirmPassword: "",
        Voucher: "",
        plan: getSelectedPlan?.plan || "Basic",
      }}
      validationSchema={validationSchema}
      onSubmit={handleSignup}
    >
      {(formik) => (
        <div>
          <Header />
          <LoadingModal show={modalShow} onHide={() => setModalShow(false)} />
          <div className="container justify-content-center my-5">
            <div className="container">
              <h2 className="bold mt-3 text-center text-uppercase">
                Registration
              </h2>
              <div className="center-icon m-auto">
                <p className="parent-signup m-auto"></p>
              </div>
              <div className="row mt-4">
                <Form className="center-form">
                  <div className="row">
                    <div className="col-12 col-md-6 mb-4 labelStyle">
                      <Input
                        label="Full Name"
                        id="form-input"
                        name="fullName"
                        type="text"
                        placeholder="Please enter your name"
                      />
                    </div>
                    <div className="col-12 col-md-6 mb-4 labelStyle">
                      <Input
                        label="Email"
                        name="email"
                        id="form-input"
                        type="email"
                        placeholder="Please enter your email"
                      />
                    </div>
                    <div className="col-12 col-md-6 mb-4 labelStyle">
                      <Input
                        label="Phone Number"
                        name="phoneNumber"
                        id="form-input"
                        type="number"
                        placeholder="Please enter your phone number"
                      />
                    </div>
                    <div className="col-12 col-md-6 mb-4 labelStyle">
                      <Input
                        label="Password"
                        name="password"
                        type="password"
                        id="form-input"
                        placeholder="Please enter your password"
                      />
                    </div>
                    <div className="col-12 col-md-6 mb-4 labelStyle">
                      <Input
                        label="Confirm Password"
                        name="confirmPassword"
                        type="password"
                        id="form-input"
                        placeholder="Please confirm your password"
                      />
                    </div>
                    <div className="col-12 col-md-6 mb-4 labelStyle">
                      <Input
                        label="Enter Voucher"
                        name="Voucher"
                        type="text"
                        id="form-input"
                        placeholder="Please Enter your voucher code if any"
                      />
                    </div>
                  </div>

                  <div className="button-div m-auto text-center">
                    <Link to="/" className="mr-2">
                      <Button className="btn mt-3" type="button" title="Back" />
                    </Link>
                    <Button
                      className="btn mt-3"
                      type="submit"
                      title="Sign Up"
                      onClick={() => {
                        window.fbq("track", "Lead");
                      }}
                    />
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      )}
    </Formik>
  );
};

export default ParentSignup;
